import { render, staticRenderFns } from "./AdLeaderboard.vue?vue&type=template&id=10531456&scoped=true"
import script from "./AdLeaderboard.vue?vue&type=script&lang=js"
export * from "./AdLeaderboard.vue?vue&type=script&lang=js"
import style0 from "./AdLeaderboard.vue?vue&type=style&index=0&id=10531456&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10531456",
  null
  
)

export default component.exports